import React from 'react';
import { css } from '@emotion/react';
import { ContextMenu, contextStyles } from '@birdi/context-menu/ContextMenu';
import { BirdiTheme, breakpoints } from '@birdi/theme';
import { useNavigate } from 'react-router';
import { ResponsiveTable } from '../../common/responsive-table';
import { useMetaSelector } from '../../meta/reducer';
import { Link } from 'react-router';

const formating = (item) => ({
  id: item.id,
  name: item.name,
  type: item.primaryOrgId ? 'Workspace' : 'Main Workspace',
  users: item.totalUsers,
  oldMissions: item.totalMissions,
  newMissions: item.totalMaps,
  isPrimary: !item.primaryOrgId,
});

export const WorkspaceTable = ({
  workspaces,
  deleteWorkspace,
  deleteWorkspaceForOneUser,
  scopeId = null,
  isCreator = false,
  createWorkspaceEnable = false,
  editWorkspaceUsersEnable = false,
}) => {
  const navigate = useNavigate();
  const meta = useMetaSelector();
  const isWorkspaceAdmin = meta.permissions.includes('workspace:user:create');

  const prepareFormatedData = (item) => [
    {
      title: 'workspace name',
      value: '',
      component: (
        <div
          css={css`
            min-width: 10em;
          `}
        >
          {isWorkspaceAdmin && !scopeId ? (
            <Link to={`/workspace-general/${item.id}`}>
              <span
                css={(theme: BirdiTheme) => css`
                  color: ${theme.deepOcean};
                `}
              >
                {item.name}
              </span>
            </Link>
          ) : (
            <span>{item.name}</span>
          )}
        </div>
      ),
    },
    {
      title: 'Workspace type',
      value: item.type,
    },
    {
      title: 'No. of users',
      value: item.users,
    },
    {
      title: 'No. of maps',
      value: item.oldMissions + item.newMissions,
    },
    {
      title: '',
      value: '',
      component: (
        <div>
          {createWorkspaceEnable && (
            <div>
              {!scopeId ? (
                <ContextMenu alignRight bottom>
                  {(props) => (
                    <div
                      css={(theme: BirdiTheme) => css`
                        ${contextStyles(theme)};
                        width: 8em;
                        button {
                          padding: 0.5em 1em;
                        }
                      `}
                    >
                      <button
                        type="button"
                        onClick={() => {
                          navigate(`/workspace-general/${item.id}`);
                          props.hide();
                        }}
                      >
                        <span>Edit</span>
                      </button>
                      {item.id !== meta.organisation.id && !item.isPrimary && (
                        <button
                          onClick={() => {
                            deleteWorkspace(item.id);
                            props.hide();
                          }}
                          type="button"
                        >
                          <span>Delete</span>
                        </button>
                      )}
                    </div>
                  )}
                </ContextMenu>
              ) : (
                !isCreator &&
                workspaces.length > 1 && (
                  <ContextMenu alignRight bottom>
                    {(props) => (
                      <div
                        css={(theme: BirdiTheme) => css`
                          ${contextStyles(theme)};
                          width: 8em;
                          button {
                            padding: 0.5em 1em;
                          }
                        `}
                      >
                        <button
                          onClick={() => {
                            deleteWorkspaceForOneUser(item.id);
                            props.hide();
                          }}
                          type="button"
                        >
                          <span>Delete</span>
                        </button>
                      </div>
                    )}
                  </ContextMenu>
                )
              )}
            </div>
          )}
        </div>
      ),
      rightAlignContextMenu: true,
    },
  ];
  const data = workspaces.map((item) => formating(item));
  const formatedData = data.map((item) => prepareFormatedData(item));

  return (
    <div
      css={(theme: BirdiTheme) => css`
        flex-grow: 1;
        margin: 1em;
        padding: 1em 0;
        border: solid 1px ${theme.mono20};
        border-radius: 10px;
        @media (max-width: ${breakpoints.xs}) {
          border: none;
        }
      `}
    >
      <ResponsiveTable
        data={formatedData}
        tableStyles={css`
          tr {
            border: none;
          }
          th {
            padding: 0 1em 1em 1em;
          }
          td {
            padding: 1em 1em 0 1em;
          }
        `}
      />
    </div>
  );
};
